import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Grid, Box, CssBaseline } from "@mui/material";

import DetailsPageHeader from "../../../../../common/DetailsPageHeader";
import GeneralAdminSidebar from "../../../../../common/GeneralAdminSidebar";
import { mainLayoutStyles, showNotification } from "../../../../../constants";
import {
  ContentDetailsStatusHistoryTable,
  ReportActionDataFieldsSection,
  ReportDetailsDataFieldsSection,
} from "../../components/components";
import {
  getSingleReport,
  updateContentReport,
} from "../../hooks/ContentReportsHooks";
import { useContentModerationContext } from "../../../../../providers/GeneralAdmin/ContentModerationProvider";
import { Toast } from "../../../../../common/alert";
import { getSingleUser } from "../../../../../modules/OrganizationQuickTales/hooks/QuickTalesHooks";

const GAContentDetailsContainer = () => {
  const { handleGetContentReports, setLoading, loading } =
    useContentModerationContext();

  const location = useLocation();
  const { id } = useParams();

  const [reportDetails, setReportDetails] = useState({});
  // const [reportDetails, setReportDetails] = useState(
  //   location?.state?.reportDetails
  // );
  const [editEnabled, setEditEnabled] = useState(false);

  useEffect(() => {
    // setReportDetails(location?.state?.reportDetails);
    fetchReportDetails();
  }, [location.state, id]);

  const fetchReportDetails = async () => {
    try {
      const reportTempData = await getSingleReport(
        location?.state?.reportDetails?.id || id.replace(":id", "")
      );
      const userTemp = await getSingleUser(reportTempData.data().reportedBy);
      let data = {
        ...reportTempData?.data(),
        id: reportTempData.id,
        // userData: userTemp,
        reportedByData: userTemp?.data() ? userTemp.data() : {},
      };
      setReportDetails(data);
    } catch (error) {
      console.error("Error fetching report details:", error);
    }
  };

  const handleUpdateReport = async () => {
    try {
      setLoading(true);
      let dataTemp = {
        status: reportDetails?.status ?? "",
        statusHistory: [
          ...reportDetails.statusHistory,
          { ...reportDetails.status },
        ],
      };
      setReportDetails({
        ...reportDetails,
        statusHistory: [
          ...reportDetails.statusHistory,
          { ...reportDetails.status },
        ],
      });
      console.log("data:", dataTemp);
      let responseTemp = await updateContentReport(reportDetails.id, dataTemp);
      await handleGetContentReports();
      console.log("update content report response:", responseTemp);
      showNotification("Content Report updated successfully.");
      // Toast("success", "Content Report updated successfully.");
    } catch (error) {
      Toast("error", error.message);
      console.log("error updating content report", error.message);
    } finally {
      setLoading(false);
      setEditEnabled(false);
    }
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <DetailsPageHeader
        mainTitle={
          editEnabled ? "Reported Details - Change Status" : "Reported Details"
        }
        // mainTitle={reportDetails?.title ? reportDetails?.title : "Report Title"}
        bgColor="#fff"
        buttonText={"Change Status"}
        editEnabled={editEnabled}
        setEditEnabled={setEditEnabled}
        cancelButton={editEnabled ? true : false}
        submitButtonText={"Save Status"}
        handleSave={() => handleUpdateReport()}
        loading={loading}
      />
      <GeneralAdminSidebar />
      <Grid container style={{ ...mainLayoutStyles, background: "#fff" }}>
        <Grid container direction={"column"} style={subContainerStyles}>
          {/*report details Data card/container section*/}
          <ReportDetailsDataFieldsSection reportDetails={reportDetails} />
          {/*Report action card/container section*/}
          <ReportActionDataFieldsSection
            reportDetails={reportDetails}
            setReportDetails={setReportDetails}
            editEnabled={editEnabled}
          />

          <ContentDetailsStatusHistoryTable
            statusHistory={reportDetails?.statusHistory ?? []}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default GAContentDetailsContainer;

const subContainerStyles = {
  paddingLeft: 30,
  paddingRight: 30,
  marginTop: 50,
};
